module.exports = __webpack_public_path__ + "media/NvShen_3.25b36b60.mp3";